import { isDefined } from '../isDefined';

export function arrayToObjectByKey(data, prop) {
  return data && Array.isArray(data) ? data.reduce((previousValue, currentValue) => {
    if (isDefined(currentValue[prop])) {
      previousValue[currentValue[prop]] = currentValue;
    }
    return previousValue;
  }, {}) : {};
}
